/**
 * Created by jonas on 2021-10-27.
 */
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {TrueGrit} from "../../TrueGrit";
import {ArrayUtils, MatrixUtils} from "../../utils/ArrayUtils";
import {TrueGritSymbol} from "../../reels/TrueGritSymbol";
import {TrueGritSymbolTransformAnimation} from "../../reels/TrueGritSymbolTransformAnimation";
import {TrueGritSound} from "../../sound/TrueGritSound";
import {ISymbol} from "../../../core/reel/ReelInterfaces";


export class TrueGritHighLowTransformPresentation implements SimplePresentation {

    constructor() {
    }


    shouldRun():boolean {
        return TrueGrit.model.highLowTransform != undefined && ArrayUtils.isAnyTrue(TrueGrit.model.highLowTransform.position);
    }


    start(controller:SimplePresentationRunnerController) {
        //Get transform symbols
        const transformSymbolPositions = ArrayUtils.getIndicesWhere(TrueGrit.model.highLowTransform!.position, ((value:boolean) => {
            return value;
        }));

        //Adding 1 to all positions (because first sym pos is 1 on bottom reel)
        for(let i:number = 0; i < transformSymbolPositions.length; i++) {
            transformSymbolPositions[i] += 1;
        }
        const transformSymbols = TrueGrit.bottomReelView.getSymbolsBySymbolPositions(transformSymbolPositions);


        //To transform symbols
        const reelSymbolsToTransformPositions = MatrixUtils.getPositionsWhere(TrueGrit.model.highLowTransform!.toTransform, value => {
            return value;
        })
        const reelSymbolsToTransform:ISymbol[] = TrueGrit.allReelsView.getSymbolsAtPositions(reelSymbolsToTransformPositions);

        const tl:gsap.core.Timeline = gsap.timeline({onComplete : () => controller.finish()});

        const transformSound:string = TrueGrit.model.highLowTransform!.isLow ? TrueGritSound.TRANSFORM_LOW_SOUND : TrueGritSound.TRANSFORM_HIGH_SOUND;
        const transformAllSound:string = TrueGrit.model.highLowTransform!.isLow ? TrueGritSound.TRANSFORM_LOW_ALL_SOUND : TrueGritSound.TRANSFORM_HIGH_ALL_SOUND;

        const hideTl:gsap.core.Timeline = gsap.timeline();
        const transformSymbolsTl:gsap.core.Timeline = gsap.timeline();
        for(let i:number = 0; i < transformSymbols.length; i++) {
            const anims = this.getSymbolTransformAnimation(<TrueGritSymbol>transformSymbols[i], true);
            transformSymbolsTl.add([
                anims.reveal,
                () => {TrueGrit.soundPlayer.playSound(transformSound)}
            ]);

            hideTl.add(anims.hide, 0);
        }

        const reelDelay = 0.00;
        const reelSymbolsTransformTl = gsap.timeline();
        for(let i:number = 0; i < reelSymbolsToTransform.length; i++) {
            if(reelSymbolsToTransform[i] == undefined) {
                throw new Error("TrueGritHighLowTransformPresentation, Symbol to be transformed is undefined");
            }
            if(i == 0 && TrueGrit.model.isTransformSymbolPartOfWin == false) {
                reelSymbolsTransformTl.add(() => {TrueGrit.soundPlayer.playSound(transformAllSound)});
            }
            const anims = this.getSymbolTransformAnimation(<TrueGritSymbol>reelSymbolsToTransform[i]);
            reelSymbolsTransformTl.add(anims.reveal, reelDelay * reelSymbolsToTransform[i].reelId);
            hideTl.add(anims.hide, 0);
        }

        if(TrueGrit.model.isTransformSymbolPartOfWin == true) {
            transformSymbolsTl.add(() => {
                if(TrueGrit.model.highLowTransform!.isLow == true) {
                    TrueGrit.soundPlayer.playSound(TrueGritSound.TRANSFORM_ALL_LOW_SOUND);
                } else {
                    TrueGrit.soundPlayer.playSound(TrueGritSound.TRANSFORM_ALL_HIGH_SOUND);
                }
                const symbols = TrueGrit.allReelsView.getAllVisibleSymbols();
                for(let symbol of symbols) {
                    transformSymbolsTl.add((<TrueGritSymbol>symbol).getShakeAnimation(2), 0);
                }
            });
        }

        tl.add(transformSymbolsTl);
        tl.add(reelSymbolsTransformTl, 0.5);
        tl.add(hideTl)

        if(tl.duration() <= 0) {
            throw new Error("TrueGritHighLowTransformPresentation duration is 0");
        }

    }

    private getSymbolTransformAnimation(orgSymbol:TrueGritSymbol, isBotSym:boolean = false):{ reveal:gsap.core.Timeline, hide:gsap.core.Timeline } {
        const isLowSymbol = TrueGrit.model.highLowTransform!.isLow;
        const transformToSymbol = TrueGrit.model.highLowTransform!.symbol;

        const symbolTransform:TrueGritSymbolTransformAnimation = new TrueGritSymbolTransformAnimation(isLowSymbol, transformToSymbol, orgSymbol.splitLevel);

        const reveal = gsap.timeline();
        reveal.add(() => {orgSymbol.addChild(symbolTransform)});

        if(TrueGrit.model.isTransformSymbolPartOfWin == true) {
            reveal.add(symbolTransform.getAttentionAnimation(isBotSym));
        }
        reveal.add(symbolTransform.getRevealTransform(isBotSym));

        reveal.add(() => {orgSymbol.symbolName = transformToSymbol});
        reveal.add(() => orgSymbol.resetPosition());
        reveal.add(() => orgSymbol.setCurrentStateSpriteTexture());
        reveal.add(() => {orgSymbol.visible = true});
        reveal.add(() => {orgSymbol.wasTransformed = true});

        const hideTl = gsap.timeline();
        hideTl.add(symbolTransform.getHide(), ">0.5");
        hideTl.add(() => {orgSymbol.removeChild(symbolTransform)});

        return {
            reveal : reveal,
            hide : hideTl,
        };

    }
}